import Navbar from "./Navbar";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <main>{children}</main>
      <footer className="max-w-7xl mx-auto px-5 sm:px-8 py-10 mt-16 border-t border-white/10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="font-mono text-xs text-white/40">
            NAŠA<span className="text-nhgreen">HUB</span> © {new Date().getFullYear()}
          </span>
          <span className="font-mono text-[11px] text-white/30 tracking-widest uppercase">
            Ex-Yu zajednica
          </span>
        </div>
      </footer>
    </div>
  );
}
